import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { MapDispatchToProps } from '../../app/utils/ConnectUtils';
import { Messages } from '../../codegen/Localize';
import { ReactModalOptions } from '../../ts/services/ReactModalService';
import { requestUploadWorkbookAction } from '../actions/UploadWorkbookActions';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';
import { UploadWorkbookDialog, UploadWorkbookDialogValues, UploadWorkbookDispatchProps } from './UploadWorkbookDialog';

export const mapDispatchToProps: MapDispatchToProps<UploadWorkbookDispatchProps> = (dispatch) => ({
  uploadWorkbookActionDispatch: (values: UploadWorkbookDialogValues, overwrite: boolean = false) => {
    dispatch(requestUploadWorkbookAction({
      data: values,
      overwrite
    }));
  }
});

const ConnectedUploadWorkbookDialog = connect(null, mapDispatchToProps)(UploadWorkbookDialog);

/**
 * Options used for ReactModalService
 */
export function UploadWorkbookDialogOpts(snapshot?: UploadWorkbookDialogValues, parentElement?: React.RefObject<any>): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    dialogContent: <ConnectedUploadWorkbookDialog close={null} snapshot={snapshot} parentElement={parentElement} />,
    title: Messages.contentUpload_workbookTitle(),
    showCloseButton: false,
    dialogWidth: UploadWorkbookStyles.dialogWidth,
    shouldNotCloseGlass: true,
    testId: 'upload-workbook'
  };
}
